import filter from "lodash/filter";
import find from "lodash/find";
import toLower from "lodash/toLower";

const DEFAULT_VALUES = {
  SELECT: null,
  TEXT: "",
};

const filterUserDefinedFields = (entityFields = {}, organizationFields) => {
  return organizationFields.reduce((acc, field) => {
    const entityField = entityFields[field.id];

    if (entityField) {
      if (field.dataType === "SELECT") {
        if (field.multiSelect) {
          if (
            !find(
              field.options,
              (o) => entityField?.includes(o.id) && !o.isArchived
            )
          ) {
            return acc;
          }
        } else {
          if (
            !find(field.options, (o) => o.id === entityField && !o.isArchived)
          ) {
            return acc;
          }
        }
      }

      if (field.dataType === "SELECT") {
        if (field.multiSelect) {
          acc[`${field.id}`] = field.options
            .filter((o) => entityField?.includes(o.id) && !o.isArchived)
            .toSorted((a, b) => {
              a = toLower(a.label);
              b = toLower(b.label);

              if (a < b) return -1;
              if (a > b) return 1;

              return 0;
            })
            .map((o) => o.id);

          return acc;
        }
      }

      acc[`${field.id}`] = entityField;
    } else {
      acc[`${field.id}`] = DEFAULT_VALUES[field.dataType];
    }

    return acc;
  }, {});
};

export const mapInitialUserDefinedFieldsState = (
  entity = {},
  { organization = {}, type }
) => {
  return {
    userDefinedFields: filterUserDefinedFields(
      entity.userDefinedFields,
      filter(organization.userDefinedFields, { type })
    ),
  };
};
